import { render } from "./MPromotionPoster.vue?vue&type=template&id=46d77275&scoped=true"
import script from "./MPromotionPoster.vue?vue&type=script&lang=js"
export * from "./MPromotionPoster.vue?vue&type=script&lang=js"

import "./MPromotionPoster.vue?vue&type=style&index=0&id=46d77275&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d77275"]])

export default __exports__